'use client';

import { forwardRef, KeyboardEvent } from 'react';
import { Search, X } from 'lucide-react';
import { Input } from './input';
import { Button } from './button';
import { cn } from '../../utils';

export interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
  showClear?: boolean;
  onKeyDown?: (event: KeyboardEvent<HTMLInputElement>) => void;
}

export const SearchInput = forwardRef<HTMLInputElement, SearchInputProps>(function SearchInput(
  {
    value,
    onChange,
    placeholder = "Search...",
    className,
    showClear = true,
    onKeyDown,
  },
  ref
) {
  return (
    <div className={ cn('relative', className) }>
      <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-muted-foreground" />
      <Input
        ref={ ref }
        type="text"
        placeholder={ placeholder }
        value={ value }
        onChange={ (e) => onChange(e.target.value) }
        onKeyDown={ onKeyDown }
        className="pl-10 pr-10 h-10 w-full bg-card border-border focus:ring-2 focus:ring-primary focus:border-primary rounded-lg"
      />
      { showClear && value && (
        <Button
          variant="ghost"
          size="sm"
          className="absolute right-1 top-1/2 transform -translate-y-1/2 h-8 w-8 p-0 hover:bg-accent"
          onClick={ () => onChange('') }
        >
          <X className="h-4 w-4" />
        </Button>
      ) }
    </div>
  );
});

SearchInput.displayName = 'SearchInput';
